import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter} from "../../../utils/formatters";

export default class locationList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "locationList"}
                {...props}
                columns={{
                    "name": {header: 'Név', width: 6, sortable, filterable},
                    "address": {header: 'Cím', width: 6, renderer: AddressFormatter},
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}
